module.exports = __webpack_public_path__ + "img/img-registration-two@3x.b6c74f62.png";